<div
  class="wishlist-create-stepper"
  role="progressbar"
  [attr.aria-valuemin]="1"
  [attr.aria-valuemax]="stepCount()"
  [attr.aria-valuenow]="activeStepIndex()"
  [attr.aria-label]="'Krok ' + activeStepIndex() + ' z ' + stepCount()"
>
  @for (step of stepperItems(); track step.id) {
    <span
      class="wishlist-create-stepper__track"
      [class.wishlist-create-stepper__track-active]="step.isActive"
      [class.wishlist-create-stepper__track-complete]="step.isComplete"
      aria-hidden="true"
    ></span>
  }
</div>
